export enum PromotionStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum AmountType {
  Amount = "Amount",
  Percentage = "Percentage",
}
